<article
  class="notification-card"
  role="button"
  tabindex="0"
  [class.unread]="notification.status === NotificationReadStatusEnum.UNREAD"
  (click)="onClick(notification)"
  (keydown.enter)="onClick(notification)"
  (keydown.space)="onClick(notification)"
>
  <div class="card-body">
    <div class="card-title-row">
      <div class="title-with-icon">
        <div class="icon-circle">
          <g99-icon-btn
            [icon]="getNotificationIcon(notification)"
            [height]="16"
            [width]="16"
          />
        </div>
        <h6 class="card-title">{{ notification.title }}</h6>
      </div>
      @if (notification.status === NotificationReadStatusEnum.UNREAD) {
        <span class="dot" aria-label="unread"></span>
      }
    </div>

    @if (notification.content) {
      <p class="card-text">{{ notification.content }}</p>
    }

    <div class="meta">{{ calculateTimeAgo(notification.createdAt) }}</div>
  </div>
</article>
